<template>
    <div class="detail-wrapper">
        <div class="left">
            <div class="info">
                <img :src="state.info.avatarUrl && state.info.avatarUrl.length > 0 ? state.info.avatarUrl.length : state.defaultAvatar" alt="">
                <div class="name">
                    {{ state.info.realName ?? '-' }}
                </div>
                <div class="phone">
                    {{ state.info.mobile ?? '-' }}
                </div>
            </div>
            <div class="click-record">
                <div class="title">
                    <el-icon>
                        <List />
                    </el-icon>
                    {{ t('personnelDetail.recentCheckin') }}
                </div>
                <div class="record">
                    <el-empty v-if="state.clickRecord.length == 0" :description="t('personnelDetail.noData')" :image-size="80" />
                    <el-timeline v-else>
                        <el-timeline-item v-for="(item, index) in state.clickRecord" :key="index">
                            <div>打卡时间：{{ formatDisplayDateTime(item.checkin_time) || '-' }}</div>
                            <div>打卡地址：{{ item.address }}</div>
                            <div>设备：{{ item.title }}（{{ item.code }}）</div>
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
            <div class="points-record">
                <div class="title">
                    <el-icon>
                        <List />
                    </el-icon>
                    {{ t('personnelDetail.recentPoints') }}
                </div>
                <div class="record">
                    <el-empty v-if="state.pointsRecord.length == 0" :description="t('personnelDetail.noData')" :image-size="80" />
                    <el-timeline v-else>
                        
                        <el-timeline-item v-for="(item, index) in state.pointsRecord" :key="index"
                            :timestamp="formatDisplayDateTime(item.checkin_time) || '-'">
                           
                            <span :style="{ color: item.change_type === 1 ? '#67C23A' : '#F56C6C' }">{{ item.change_type
                                === 1 ? '+' : '-' }}{{ item.points }}</span>
                            （{{ item.reason }}）
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="overview">
                <div class="item border-right">
                    <span><span class="number">{{ state.info.points }}</span></span>
                    <span class="text">{{ t('personnelDetail.points') }}</span>
                </div>
                <div class="item border-right">
                    <span><span class="number">{{ state.overview.goToWork }}</span>天</span>
                    <span class="text">{{ t('personnelDetail.monthCheckinDays') }}</span>
                </div>
                <div class="item border-right">
                    <span><span class="number">{{ state.overview.otDay }}</span>天</span>
                    <span class="text">{{ t('personnelDetail.monthOtDays') }}</span>
                </div>
                <div class="item border-right">
                    <span><span class="number">{{ state.overview.otTime }}</span>小时</span>
                    <span class="text">{{ t('personnelDetail.monthOtHours') }}</span>
                </div>
                <div class="item border-right">
                    <span><span class="number">{{ state.overview.zhiDay }}</span>天</span>
                    <span class="text">{{ t('personnelDetail.monthZhiDays') }}</span>
                </div>
                <div class="item">
                    <span><span class="number">{{ state.overview.zhiTime }}</span>小时</span>
                    <span class="text">{{ t('personnelDetail.monthZhiHours') }}</span>
                </div>
            </div>
            <div class="my-special" ref="myElementRef">
                <div ref="searchBox">
                    <hc-search :data="searchData" @serch="getSearch">
                        <template #btns>
                            <el-button type="primary" icon="Plus" @click="$refs['bindMachine'].open()">绑定设备</el-button>
                        </template>
                    </hc-search>
                </div>
                <!-- 表格 -->
                <div class="table_box">
                    <hc-table :tableData="state.tableData" :column="state.tableHeader" :loading="state.tableLoading"
                        :offsetHeight="state.offsetHeight" :maxPage="maxPage" @pageChange="pageChange"
                        @limitChange="limitChange">
                        <template #status="{ row }">
                            {{ listToMap(statusOptions, {})[row.status] }}
                        </template>
                        <template #operation="scope">
                            <div class="btn_box_det">
                                <el-button size="small" class="opBtn" type="danger" link
                                    @click="deleteBind(scope.row)">解绑</el-button>
                            </div>
                        </template>
                    </hc-table>
                </div>
            </div>
        </div>

        <BindMachine ref="bindMachine" :user_id="state.info.id" @refresh="getSearch(searchData)" />
    </div>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    nextTick,
    defineEmits,
    defineProps,
    defineExpose,
    toRaw
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import { List } from '@element-plus/icons-vue'
import { getUerInfoAPi, getClickRecordApi, getOverviewApi, getPointsRecordApi, getUserDeviceListApi, delBindApi } from "@/api/machinist/detail.js";
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { listToMap } from "@/utils/utils";
import { formatDisplayDateTime } from "@/utils/dateTime.js";
import BindMachine from "./components/bindMachine.vue";
import { t } from "@/composables/usePageI18n.js";
const emit = defineEmits([]);

const router = useRouter();
const route = useRoute();

const myElementRef = ref();
const searchBox = ref();
const bindMachine = ref();


let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const statusOptions = reactive([
    { label: "启用", value: 1 },
    { label: "停用", value: 0 }
])

const searchData = reactive([
    {
        label: "关键词",
        type: "input",
        value: "",
        field: 'keywords'
    },
]);
const state = reactive({
    dialogVisible: false,
    info: {

    },
    defaultAvatar: require('@/assets/user/avatar.png'),
    clickRecord: [
    ],
    pointsRecord: [
        // {
        //     "reason": "技能学习：测试任务2",
        //     "user_id": 3,
        //     "mobile": "13333333333",
        //     "created_at": "2025-05-31 15:35:12",
        //     "change_type": 1,
        //     "real_name": "玩大锤",
        //     "id": 7,
        //     "points": 1,
        //     "username": "wdc"
        // },
        // {
        //     "reason": "技能学习：测试技能提升 任务",
        //     "user_id": 3,
        //     "mobile": "13333333333",
        //     "created_at": "2025-05-31 15:33:28",
        //     "change_type": 1,
        //     "real_name": "玩大锤",
        //     "id": 6,
        //     "points": 5,
        //     "username": "wdc"
        // },
        // {
        //     "reason": "技能学习：测试任务2",
        //     "user_id": 7,
        //     "mobile": "16666666666",
        //     "created_at": "2025-05-31 15:31:28",
        //     "change_type": 1,
        //     "real_name": "王路飞",
        //     "id": 5,
        //     "points": 1,
        //     "username": "wlf"
        // },
        // {
        //     "reason": "技能学习：测试技能提升 任务",
        //     "user_id": 3,
        //     "mobile": "13333333333",
        //     "created_at": "2025-05-31 15:31:22",
        //     "change_type": 1,
        //     "real_name": "玩大锤",
        //     "id": 4,
        //     "points": 5,
        //     "username": "wdc"
        // },
        // {
        //     "reason": "完成特殊任务：第二个特殊任务",
        //     "user_id": 7,
        //     "mobile": "16666666666",
        //     "created_at": "2025-05-30 17:27:00",
        //     "change_type": 1,
        //     "real_name": "王路飞",
        //     "id": 3,
        //     "points": 20,
        //     "username": "wlf"
        // },
        // {
        //     "reason": "完成特殊任务：测试发布人参数",
        //     "user_id": 3,
        //     "mobile": "13333333333",
        //     "created_at": "2025-05-21 22:50:26",
        //     "change_type": 1,
        //     "real_name": "玩大锤",
        //     "id": 2,
        //     "points": 1,
        //     "username": "wdc"
        // },
        // {
        //     "reason": "技能学习",
        //     "user_id": 1,
        //     "mobile": "13456214521",
        //     "created_at": "2025-05-08 19:38:41",
        //     "change_type": 1,
        //     "real_name": "张三",
        //     "id": 1,
        //     "points": 10,
        //     "username": "jishou0001"
        // }
    ],
    overview: {},
    tableLoading: false,
    column: [
        {
            prop: "id",
            show: false,
            label: "任务ID",
        },
        {
            // prop: "id",
            show: true,
            type: "index",
            label: "序号",
            width: 80,
        },
        {
            prop: "code",
            show: true,
            label: "编码",
        },
        {
            prop: "title",
            show: true,
            label: "设备名称",
        },
        {
            prop: "kilometer",
            show: true,
            label: "公里数",
        },
        {
            prop: "status",
            show: true,
            label: "状态",
        },
        {
            prop: "operation",
            show: true,
            label: "操作",
            width: 100
        },
    ],
    offsetHeight: 0,
    tableHeader: [],
    tableData: [
        // {
        //     "score": 20,
        //     "start_time": "2027-05-31 01:03:57",
        //     "updated_at": "2025-05-30 17:04:12",
        //     "end_time": "2028-05-31 01:03:59",
        //     "description": "测测测次",
        //     "created_at": "2025-05-30 17:04:12",
        //     "real_name": "艾斯",
        //     "id": 6,
        //     "title": "第二个特殊任务",
        //     "url": "[{\"url\":\"https://newocean.oss-accelerate.aliyuncs.com/source/1748595850019.jpg\"}]",
        //     "replied_by": 6,
        //     "status": 1
        // },
        // {
        //     "score": 10,
        //     "start_time": "2025-05-30 23:47:31",
        //     "updated_at": "2025-05-30 15:47:49",
        //     "end_time": "2025-06-30 23:47:32",
        //     "description": "艾斯发布了第一个特殊任务",
        //     "created_at": "2025-05-30 15:47:49",
        //     "real_name": "艾斯",
        //     "id": 5,
        //     "title": "艾斯发布的第一个特殊任务",
        //     "url": "[{\"url\":\"https://newocean.oss-accelerate.aliyuncs.com/source/1748591268565.jpg\"},{\"url\":\"https://newocean.oss-accelerate.aliyuncs.com/source/1748591268456.jpg\"},{\"url\":\"https://newocean.oss-accelerate.aliyuncs.com/source/1748591268058.webp\"}]",
        //     "replied_by": 6,
        //     "status": 1
        // },
        // {
        //     "score": 10,
        //     "start_time": "2025-05-24 22:52:15",
        //     "updated_at": "2025-05-24 14:52:30",
        //     "end_time": "2025-12-24 22:52:17",
        //     "description": "chess撒带上打卡啦还上课",
        //     "created_at": "2025-05-24 14:52:30",
        //     "real_name": "艾斯",
        //     "id": 4,
        //     "title": "as测试",
        //     "url": "[{\"url\":\"https://newocean.oss-accelerate.aliyuncs.com/source/1748069554146.jpeg\"},{\"url\":\"https://newocean.oss-accelerate.aliyuncs.com/source/1748069555575.jpeg\"}]",
        //     "replied_by": 6,
        //     "status": 1
        // },
        // {
        //     "score": 1,
        //     "start_time": "2025-05-17 08:00:00",
        //     "updated_at": "2025-05-21 21:37:24",
        //     "end_time": "2025-05-16 08:00:00",
        //     "description": "策划9i啊谁丢啊还是",
        //     "created_at": "2025-05-21 21:37:24",
        //     "real_name": "超级管理员",
        //     "id": 3,
        //     "title": "测试发布人参数",
        //     "url": "[\"https://newocean.oss-accelerate.aliyuncs.com/source/1747834637384.jpeg\"]",
        //     "replied_by": 2,
        //     "status": 1
        // },
        // {
        //     "score": 5,
        //     "start_time": "2025-05-22 08:00:00",
        //     "updated_at": "2025-05-21 20:57:13",
        //     "end_time": "2025-05-31 08:00:00",
        //     "description": "测试描述111111",
        //     "created_at": "2025-05-21 20:57:13",
        //     "id": 2,
        //     "title": "测试特殊任务1",
        //     "url": "[\"https://newocean.oss-accelerate.aliyuncs.com/source/1747832224477.jpeg\",\"https://newocean.oss-accelerate.aliyuncs.com/source/1747832231708.jpeg\"]",
        //     "replied_by": 0,
        //     "status": 0
        // },
        // {
        //     "score": 10,
        //     "start_time": "2025-05-09 22:50:05",
        //     "updated_at": "2025-05-20 20:21:37",
        //     "end_time": "2025-05-31 22:50:11",
        //     "description": "特殊任务特殊任务特殊任务特殊任务",
        //     "created_at": "2025-05-08 22:50:17",
        //     "real_name": "张三",
        //     "id": 1,
        //     "title": "特殊任务",
        //     "replied_by": 1,
        //     "status": 1
        // }
    ]
});

const getPersonDetail = () => {
    const params = JSON.stringify({
        id: route.query.id
    })
    getUerInfoAPi(params).then(res => {
        if (res?.code === 200) {
            state.info = res?.data ?? {};
        }
    })
}

const getClickRecord = () => {
    const date = new Date()
    const params = JSON.stringify({
        "time": `${date.getFullYear()}-${date.getMonth() + 1}`,
        "user_id": route.query.id
    })
    getClickRecordApi(params).then(res => {
        if (res?.code === 200) {
            if (!res?.data || res.data.length == 0) {
                state.clickRecord = []
                return
            }
            const filterList = filterHasRecordData(res.data)
            if (filterList < 3) {
                let list = []
                filterList.forEach(item => {
                    item.goToWork[0] && list.push(item.goToWork[0])
                    item.goOffWork[0] && list.push(item.goOffWork[0])
                    list.concat([...item.workOvertime])
                });
                state.clickRecord = list
            } else {
                let list = []
                filterList.slice(-3).forEach(item => {
                    item.goToWork[0] && list.push(item.goToWork[0])
                    item.goOffWork[0] && list.push(item.goOffWork[0])
                    list.concat([...item.workOvertime])
                });
                state.clickRecord = list
            }
        }
    })
}

// 过滤出有打卡记录的数据
const filterHasRecordData = (arr) => {
    return arr.filter(item => {
        return item.goToWork.length > 0 || item.goOffWork.length > 0 || item.workOvertime.length > 0
    })
}

const getOverview = () => {
    const date = new Date()
    const month = date.getMonth() + 1
    const params = JSON.stringify({
        "time": `${date.getFullYear()}-${month < 10 ? '0' + month : month}`,
        "user_id": route.query.id
    })
    getOverviewApi(params).then(res => {
        if (res?.code === 200) {
            state.overview = res?.data ?? {};
        }
    })
}

const getPointsRecord = () => {
    const params = JSON.stringify({
        "page": 1,
        "user_id": route.query.id
    })
    getPointsRecordApi(params).then(res => {
        if (res?.code === 200) {
            state.pointsRecord = res?.data ?? [];
        }
    })
}

const deleteBind = (row) => {
    ElMessageBox.confirm(
        `确认要解除绑定[${row.title}]吗?`,
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            const params = JSON.stringify({
                id: row.id
            })
            delBindApi(params).then(res => {
                if (res?.code === 200) {
                    ElMessage.success(res?.msg ?? '解绑成功')
                    getSearch(searchData)
                }
            })
        })
        .catch(() => {

        })
}

const init = () => {
    getPersonDetail()
    getClickRecord()
    getOverview()
    getPointsRecord()
    getSearch(searchData)
};

// 动态改变表头
const change = (item) => {
    tableHeaderFn();
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {
    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
    getSearch(searchData)
}

// 查询过来的数据
const getSearch = (params = []) => {
    state.tableLoading = true
    const form = listToMap(toRaw(params), { value: 'value', key: 'field' })
    const requestParams = {
        page: page.value,
        limit: limit.value,
        user_id: route.query.id,
        ...form
    }
    getUserDeviceListApi(JSON.stringify(requestParams)).then(res => {
        maxPage.value = res?.maxPage ?? 0;
        state.tableData = res?.data?.map(item => {
            return {
                ...item,
            }
        }) ?? []
    }).catch(() => {
        maxPage.value = 0
        state.tableData = []
    }).finally(() => {
        state.tableLoading = false
    })
};

// 表头筛选
const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};

onMounted(() => {
    try {
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        tableHeaderFn();
        init()
    } catch (error) {

    }
});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.detail-wrapper {
    display: flex;
    width: 100%;
    height: 100%;
    min-height: 700px;
    overflow: auto;

    .left {
        width: 400px;
        height: 100%;
        padding-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .info,
        .click-record,
        .points-record {
            width: calc(100% - 20px);
            height: calc(32% - 20px);
            background-color: #fff;
            border-radius: 6px;
            padding: 10px;
        }

        .info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img {
                width: 60px;
                height: 60px;
                border-radius: 50%;
            }

            .name {
                font-size: 28px;
                font-weight: bold;
                color: #333;
                margin: 10px 0;
            }

            .mobile {
                font-size: 18px;
                color: #999;
            }
        }

        .click-record,
        .points-record {
            .title {
                width: 100%;
                height: 40px;
                line-height: 40px;
                font-size: 16px;
            }

            .record {
                height: calc(100% - 40px);
                overflow-y: auto;
            }
        }
    }

    .right {
        width: calc(100% - 430px);
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 0 10px;

        .overview,
        .my-special {

            background-color: #fff;
            border-radius: 6px;
        }

        .overview {
            width: calc(100% - 20px);
            height: 150px;
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .item {
                width: calc((100% - 20px) / 6);
                height: 80%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                color: #262727;
                cursor: pointer;
                scale: (1);
                transition: all .5s;

                &:hover {
                    scale: (1.2);
                }

                .number {
                    font-size: 26px;
                    color: #409EFF;
                }

                .text {
                    font-size: 14px;
                    color: #58585B;
                }
            }

            .border-right {
                border-right: 1px solid #E6E6E6;
            }
        }

        .my-special {
            height: calc(100% - 160px);
            margin-top: 10px;

            ::v-deep .hc-search {
                background-color: #fff;
            }
        }
    }
}
</style>
